/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { bulkPartialPatchDependencyResultSchema } from './bulkPartialPatchDependencyResultSchema';
import { bulkPatchItemErrorSchema } from './bulkPatchItemErrorSchema';
import { bulkPatchItemFieldSkipSchema } from './bulkPatchItemFieldSkipSchema';

export const bulkPartialPatchResponseSchema = z.object({
  get dependencyResult() {
    return z.union([bulkPartialPatchDependencyResultSchema, z.null()]).optional();
  },
  get failed() {
    return z.array(bulkPatchItemErrorSchema);
  },
  get skipped() {
    return z.array(bulkPatchItemFieldSkipSchema);
  },
});
